import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import TourSection from "@/components/TourSection";
import MailingListSection from "@/components/MailingListSection";
import StoreSection from "@/components/StoreSection";
import BandSection from "@/components/BandSection";
import Footer from "@/components/Footer";

const Index = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navigation />
      <HeroSection />
      <TourSection />
      <MailingListSection />
      <StoreSection />
      <BandSection />
      <Footer />
    </div>
  );
};

export default Index;
